module.exports = __webpack_public_path__ + "img/fondeg.09b11057.jpg";